export default __webpack_public_path__ + "static/media/new_floating_tele.b0b81fa5.svg";